import React from 'react'
import PropTypes from 'prop-types'

import Conditional from 'components/Conditional'
import { Switch, Tooltip } from '@material-ui/core'

const classes = {
  wrapper: 'DatasetBox-config-content-wrapper',
  ruleWrapper: 'DatasetBox-config-content-DatasetRule-wrapper',
}

const DatasetConfig = ({ config, meta: tempMeta = [], stackedBy, callback }) => {
  const meta = tempMeta.map(feature => ({
    ...feature,
    active:
      feature.id === stackedBy ||
      // eslint-disable-next-line camelcase
      !config.rules.find(({ feature_id }) => feature.id === feature_id),
  }))
  return (
    <div className={classes.wrapper}>
      {meta.map(({ id, name, _, active }) => {
        return (
          <div key={id} className={classes.ruleWrapper}>
            <Tooltip
              title={name.charAt(0).toUpperCase() + name.slice(1)}
              placement="right"
            >
              <span>{name.charAt(0).toUpperCase() + name.slice(1)}</span>
            </Tooltip>
            <Conditional dependencies={id === stackedBy}>
              <span>stacked by this feature</span>
            </Conditional>
            <Switch
              checked={!!active}
              color={active ? 'primary' : 'default'}
              disabled={id === stackedBy}
              onChange={event => {
                if (!event.target.checked) {
                  const tempConfig = { ...config }
                  tempConfig.rules = [
                    ...config.rules,
                    { feature_id: id, active: event.target.checked },
                  ]
                  callback({ ...tempConfig })
                } else {
                  const tempConfig = { ...config }
                  tempConfig.rules = [...config.rules].filter(
                    e => e.feature_id !== id
                  )
                  callback({ ...tempConfig })
                }
              }}
            />
          </div>
        )
      })}
    </div>
  )
}

DatasetConfig.propTypes = {
  config: PropTypes.object,
  meta: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.oneOf(['numeric', 'category', 'time', 'text']),
    })
  ),
  stackedBy: PropTypes.number,
  callback: PropTypes.func,
}

export default DatasetConfig
